import React from 'react'

const PlayIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" 
        width="18" height="18" viewBox="0 0 24 24"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" 
        className="play-icon">
      <polygon points="5 3 19 12 5 21 5 3"></polygon>
    </svg>
  )
}

export default PlayIcon


// WEBPACK FOOTER //
// ./src/assets/icons/play-icon.js